/* global API */

import { Controller } from 'stimulus';
import formatPrice from '../helpers/formatPrice';
import cookie from '../helpers/cookie';
import toArray from '../helpers/toArray';

const MIN_ITEMS = 2;
const MAX_ITEMS = 3;

class CompareController extends Controller {
  connect() {
    this.updateCompareSession();
  }

  onCheckboxChange(e) {
    let items = this.getCompareItemsFromCookie();

    if (items.indexOf(e.currentTarget.value) >= 0) {
      items = items.filter((item) => item !== e.currentTarget.value);
    } else {
      items.push(e.currentTarget.value);
    }

    cookie.set('compareItems', items, 48 * 60);

    window.app.tracking.shootEvent('Vergelijken', 'click', e.currentTarget.value);

    this.updateCompareSession();
  }

  onRemoveItemClick(e) {
    const { currentTarget } = e;
    const id = parseInt(currentTarget.dataset.itemId, 10);
    const checkbox = this.checkboxTargets
      .filter((checkboxItem) => parseInt(checkboxItem.value, 10) === id)[0];

    if (typeof checkbox !== 'undefined') {
      checkbox.checked = false;
    }

    const filteredItems = this.getCompareItemsFromCookie()
      .filter((item) => parseInt(item, 10) !== id);

    cookie.set('compareItems', filteredItems, 60);

    this.updateCompareSession();
    this.removeItemFromTable(currentTarget);
  }

  removeItemFromTable(item) {
    if (!item.hasAttribute('data-remove-item')) return;

    const tableCell = item.closest('[data-target="compare.tableCol"]');
    const tableRow = item.closest('[data-target="compare.tableRow"]');
    const tableRowCells = toArray(tableRow.children);
    const tableCellIndex = tableRowCells.indexOf(tableCell);
    const tableRows = toArray(this.tableTarget.querySelectorAll('[data-target="compare.tableRow"]'));

    tableRows.forEach((row) => {
      const cells = toArray(row.querySelectorAll('[data-target="compare.tableCol"]'));

      cells[tableCellIndex].remove();
    });

    if (!this.getCompareItemsFromCookie().length) {
      window.location.href = '/';
    }
  }

  onCompareButtonClick(e) {
    if (this.getCompareItemsFromCookie().length < MIN_ITEMS) {
      e.preventDefault();
    }

    window.app.tracking.shootEvent('Vergelijken', 'click', 'Naar vergelijken pagina');
  }

  onCompareToggleClick() {
    this.listTarget.classList.toggle('is-open');
  }

  updateCompareSession() {
    this.disableCheckboxes();
    this.enableCompareButton();
    this.toggleCompareList();
    this.updateCount();

    $.ajax({
      type: 'POST',
      url: API.compare,
      dataType: 'json',
      data: {
        items: this.getCompareItemsFromCookie(),
      },
      success: (res) => this.updateCompareItems(res),
    });
  }

  updateCount() {
    if (!this.hasCountTarget) return;

    this.countTarget.innerHTML = `(${this.getCompareItemsFromCookie().length || 0})`;
  }

  updateCompareItems(items) {
    if (!this.hasItemsTarget) return;

    this.itemsTarget.innerHTML = '';
    items.forEach((item) => this.itemsTarget.appendChild(this.renderItem(item)));
  }

  toggleCompareList() {
    if (!this.hasListTarget) return;

    this.listTarget.classList.toggle('is-visible', this.getCompareItemsFromCookie().length);
  }

  // eslint-disable-next-line class-methods-use-this
  getCompareItemsFromCookie() {
    if (!cookie.get('compareItems')) {
      return [];
    }

    return cookie.get('compareItems').split(',');
  }

  getCheckedCheckboxValues() {
    return this.checkboxTargets
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => parseInt(checkbox.value, 10));
  }

  enableCompareButton() {
    if (!this.hasCompareButtonTarget) return;

    this.compareButtonTarget
      .classList
      .toggle('disabled', this.getCompareItemsFromCookie().length < MIN_ITEMS);
  }

  disableCheckboxes() {
    this.checkboxTargets
      .filter((checkbox) => !checkbox.checked)
      .forEach((checkbox) => {
        checkbox.disabled = this.getCompareItemsFromCookie().length === MAX_ITEMS;
      });
  }

  /**
   * Render and return the item for the compare list
   *
   * @param item
   * @returns HTMLDivElement
   */
  // eslint-disable-next-line class-methods-use-this
  renderItem(item) {
    const element = document.createElement('div');
    element.classList.add('compare-list__item');
    element.innerHTML = `
      <img
        src="${item.image}"
        alt="${item.title}"
        class="compare-list__item-image img-fluid"
      >

      <div class="d-flex flex-column flex-grow-1 pr-1">
        <a href="${item.url}" class="compare-list__item-title">${item.title}</a>
        <span class="compare-list__item-price">${formatPrice(item.price, 2, '')}</span>
      </div>

      <button
        type="button"
        class="compare-list__item-remove btn--reset"
        data-item-id="${item.id}"
        data-action="click->compare#onRemoveItemClick"
      >
        &times;
      </button>
    `;

    return element;
  }
}

CompareController.targets = [
  'checkbox',
  'items',
  'list',
  'count',
  'table',
  'tableRow',
  'tableCol',
  'compareButton',
];

export default CompareController;
